import * as React from 'react';
import { resolveSyncIfLoadedOrThrow } from '@avensia/excite';

interface ContentListEntryComponent {
  index: number;
}
interface Props extends ContentListEntryComponent {
  item: Excite.Contentful.CFBaseEntryApiModel;
}

export default React.memo(function ContentListEntry({ item, index }: Props) {
  const itemWithComponentName = item as unknown as Excite.ContentApi.IComponent;
  const Component = resolveSyncIfLoadedOrThrow(itemWithComponentName.componentName);

  return <Component {...item} index={index} />;
});
